import React from 'react';

import ProfileFeed from 'src/components/ProfileFeed';

const UserScreenLoading = (): JSX.Element | null => <ProfileFeed loadingUser />;

export default UserScreenLoading;
